import React from 'react';
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as ProxyHelper from "../proxyManagement/ProxyHelper";

class Error extends React.PureComponent {

    handleTryAgain = () => {
        const { navigateToProxyRequestDOB } = this.props;
        navigateToProxyRequestDOB();
    }
    handleClick = (event) => {
        const { listOfSelectedProxyUsers, navigateToManageNotifications, navigateToProxyRequestDOB, proxyRequestData, setSelectedProxyUsers } = this.props;
        const isProxyFlowCompletedForAllUsers = listOfSelectedProxyUsers?.length > 0 && listOfSelectedProxyUsers.every(user => user.hasError === true || user.isCompleted === true);
        let temp = [...listOfSelectedProxyUsers];
        let clickedBtnLog = event == 'continue' ? "Continue" : "TryAgainLater";
        temp.forEach((user) => {
            if (proxyRequestData.firstName === user?.proxyRequest?.receiver?.firstName && proxyRequestData.lastName === user?.proxyRequest?.receiver?.lastName) {
                return user.isCompleted = true;
            }
        });
        setSelectedProxyUsers(temp);
        let count = listOfSelectedProxyUsers?.length > 0
        let activeUser = `${proxyRequestData.firstName}${proxyRequestData.lastName}`;

        listOfSelectedProxyUsers?.length > 0 && !isProxyFlowCompletedForAllUsers ?
            (logUI(`MBHWeb.UI.ProxyRequest.Failed.${clickedBtnLog}${ProxyHelper.getProxySuggestions(count)}`, new Date(), Tools.getURLPath(), { currentProxySuggestionUser: activeUser }),
        navigateToProxyRequestDOB())
			:
        listOfSelectedProxyUsers?.length > 0 ? this.props.history.push('/onboarding/summary') :
            navigateToManageNotifications()

    }
    

    render() {

        const { errorData, errorOn, hideRetry, navigateToManageAccount, showManageAccountAccess, navigateToManageNotifications, useOnboardingLayout, navigateToProxyRequestDOB } = this.props;
        const statusColor = (errorData|| errorOn) ? "error-status" : "";

        return (<>
            {errorData && errorData.length > 0 &&
                <div className={`proxy-msg-container ${statusColor}`}>
                    {errorData.map((error, index) => (
                        <div key={index} className="proxy-msg-block">
                            {/*<div className="proxy-msg__heading">{error.heading}</div>*/}
                            {error.message && <div className="proxy-msg__status">{error.message}</div>}
                            {error.info && <div className="proxy-msg__info">{error.info}</div>}
                        </div>)
                    )}
                    {!hideRetry &&
                        <>{useOnboardingLayout
                            ? <>
                                <div className="proxy-msg__btn error-display">
                                    <input type="button" className="btn text-btn" value="TRY AGAIN" onClick={() => this.handleTryAgain()} />
                                    <input type="button" className="btn text-btn" value="DO THIS LATER" onClick={() => this.handleClick('doThisLater')} />
                                </div>
                            </>
                            : <div className="proxy-msg__btn">
                                <input type="submit" className="btn text-btn" value="Try again" onClick={() => this.props.onRetry(errorOn)} />
                            </div>
                        }</>
                    }
                    {showManageAccountAccess &&
                        <>{useOnboardingLayout
                            ? <div className="proxy-msg__btn">
                                <input type="button" className="btn text-btn" value="CONTINUE" onClick={() =>this.handleClick('continue')} />
                            </div>
                            : <div className="proxy-msg__btn">
                                <input type="button" className="btn text-btn" value="Manage family accounts" onClick={() => navigateToManageAccount()} />
                            </div>
                        }
                        </>
                    }
                </div>
            }

        </>);
    }
}
const mapStateToProps = (state) => {
    return {
        useOnboardingLayout: state.session.useOnboardingLayout,
        history: state.session.history,
        listOfSelectedProxyUsers: state.session.selectedProxySuggestionUsers
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedProxyUsers: (selectedProxySuggestionUsers) => dispatch({ type: types.SET_PROXY_SELECTED_USERS, selectedProxySuggestionUsers })
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(Error);
